// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"105":"6ffebbe1","168":"a85be6dd","453":"c79c1dcc"}[chunkId] + ".js";
};